import React from "react";
import Head from "next/head";
import Header from "../components/newHeader/Header";
import Footer from "../components/newFooter";
import styles from "./tos.module.scss";

export default function CustomerFaq() {
  return (
    <div>
      <Head>
        {/*  Facebook tags  */}
        <meta name="og:title" content="Privacy Policy" key="title" />
        <meta name="og:type" content="website" key="type" />
        <meta
          name="og:url"
          content={`${process.env.NEXT_PUBLIC_ROOT_URL}/policy`}
          key="url"
        />
        <meta
          name="og:description"
          content="We take your privacy very seriously. We strongly recommend that you read the Mawoo Pets Privacy Policy carefully to learn how we handle information and data."
        />
        <meta name="og:locale" content="en_US" key="locale" />
        {/*  standard tags  */}
        <title>Privacy Policy</title>

        <meta
          name="description"
          content="We take your privacy very seriously. We strongly recommend that you read the Mawoo Pets Privacy Policy carefully to learn how we handle information and data."
        />
        <meta
          name="robots"
          content={
            process.env.NEXT_PUBLIC_ROOT_URL === "https://www.mawoopets.com"
              ? "index, follow"
              : "noindex, nofollow"
          }
        />
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_ROOT_URL}/policy`}
        />
      </Head>
      <Header />
      <main className={styles.main}>
        <h1 className={styles.title}>MAWOO PETS PRIVACY POLICY</h1>
        <p className="p2">
          <strong>Effective as of October 19th, 2020</strong>
        </p>
        <p className="p2">Welcome to the Mawoo Pets website!</p>
        <p className="p2">
          Mawoo Pets Ltd. and Mawoo Pets LLC (collectively, &ldquo;
          <strong>Mawoo Pets</strong>&rdquo;, &ldquo;<strong>we</strong>&rdquo;,
          &ldquo;<strong>our</strong>&rdquo; and &ldquo;<strong>us</strong>
          &rdquo;) are committed to protecting any personal information which
          you may provide while using, or that we may obtain from your use of,
          the Mawoo Pets website (&ldquo;<strong>Website</strong>&rdquo;) or the
          emails we send to you. We have created this Privacy Policy (the
          &ldquo;<strong>Privacy</strong> <strong>Policy</strong>&rdquo;) to
          demonstrate our commitment to protecting your privacy.
        </p>
        <p className="p2">
          The services provided through the Website (&ldquo;
          <strong>Services</strong>&rdquo;) are made available to you (&ldquo;
          <strong>you</strong>&rdquo; and &ldquo;<strong>your</strong>&rdquo;
          refers to a visitor or to a registered user of the Website) on your
          computer, tablet or smart phone (&ldquo;<strong>Device</strong>
          &rdquo;).<span className="Apple-converted-space">&nbsp; </span>In
          order to use our Services, you must agree to the Privacy Policy
          contained herein and our{" "}
          <a href={`${process.env.NEXT_PUBLIC_ROOT_URL}/tos`}>
            <span className="s8">Terms and Conditions </span>
          </a>
          .
        </p>
        <p className="p2">
          YOU MUST BE 13 YEARS OF AGE OR OLDER TO REGISTER OR USE OUR SERVICES.
          We do not knowingly collect information from children under the age of
          13. If we become aware that we have inadvertently received personal
          information from a child under the age of 13, we will delete such
          information from our records.
        </p>
        <p className="p2">
          BY USING OUR WEBSITE, YOU CONSENT TO THE COLLECTION, STORAGE, USE,
          DISCLOSURE AND RETENTION OF YOUR PERSONAL INFORMATION BY MAWOO PETS IN
          ACCORDANCE WITH THIS PRIVACY POLICY.
          <span className="Apple-converted-space">&nbsp; </span>IF YOU DO NOT
          AGREE WITH THIS PRIVACY POLICY, YOU SHOULD NOT ACCESS OR USE OUR
          WEBSITE
        </p>
        <p className="p3">&nbsp;</p>
        <ol className="ol1">
          <li className="li2">
            <strong>OVERVIEW OF OUR PRIVACY POLICY</strong>
          </li>
        </ol>
        <p className="p2">
          The purpose of this Privacy Policy is to inform you of our privacy
          practices and policies, including:
        </p>
        <ul className="ul1">
          <li className="li2">
            what personal information we collect and why we collect it;&nbsp;
          </li>
          <li className="li2">how we use your personal information;</li>
          <li className="li2">
            who we share your personal information with; and
          </li>
          <li className="li2">
            your options to control access, update and remove your personal
            information from the Website; and
          </li>
          <li className="li2">
            who you can contact should you have questions or concerns about our
            privacy practices.&nbsp;
          </li>
        </ul>
        <p className="p4">
          This Privacy Policy is designed to comply with applicable privacy
          legislation in Canada, including the{" "}
          <em>Personal Information Protection and Electronic Documents Act</em>{" "}
          (&ldquo;<em>PIPEDA</em>&rdquo;). You should read this Privacy Policy
          carefully. This Privacy Policy is incorporated into and forms part of
          and is subject to our{" "}
          <a href={`${process.env.NEXT_PUBLIC_ROOT_URL}/tos`}>
            <span className="s8">Terms and Conditions </span>
          </a>
          .
        </p>
        <table className="t1" cellSpacing="0" cellPadding="0">
          <tbody>
            <tr>
              <td className="td1" valign="top">
                <p className="p2">
                  <span className="s1">
                    <strong>
                      <em>Overview of Our Privacy Practices</em>
                    </strong>
                  </span>
                </p>
                <p className="p2">
                  <em>
                    Our privacy practices are summarized here. Under this
                    Privacy Policy, we:
                  </em>
                </p>
                <ol className="ol1">
                  <li className="li2">
                    <em>
                      collect personal information when you access or use the
                      Website or correspond with us for the purpose outlined in
                      Section 4 of this Privacy Policy;
                    </em>
                  </li>
                  <li className="li2">
                    <em>
                      collect non-identifiable information regarding Website
                      users and activity on the Website;
                    </em>
                  </li>
                  <li className="li2">
                    <em>
                      share the information we collect with authorized
                      employees, agents, partners, service providers and legal
                      representatives, and may also share this information with
                      third parties engaged to provide products and services on
                      our behalf. Such persons may only use your personal
                      information for the purposes you have consented to within
                      this Privacy Policy;{" "}
                    </em>
                  </li>
                  <li className="li2">
                    <em>
                      may use, share and disclose the information collected by
                      Mawoo Pets Ltd. with Mawoo Pets LLC, and vice-versa, all
                      in accordance with this Privacy Policy;
                    </em>
                  </li>
                  <li className="li2">
                    <em>
                      except as set out in Section 5 of this Privacy Policy, we
                      do not share your personal information with third parties
                      without your consent;
                    </em>
                  </li>
                  <li className="li2">
                    <em>
                      retain your personal information in compliance with our
                      legal obligations and only as long as necessary for the
                      purposes of which it was collected; and
                    </em>
                  </li>
                  <li className="li2">
                    <em>
                      may share your personal information with our partners or
                      service providers operating outside of Canada, including
                      those in the United States.
                    </em>
                  </li>
                </ol>
                <p className="p2">
                  <em>
                    We mitigate the risk and impact of potential harms involved
                    in the disclosure of personal information through the
                    adoption of reasonable physical, technical and
                    organizational procedures appropriate to the sensitivity of
                    the data in an effort to safeguard the personal information
                    you provide to us.&nbsp;
                  </em>
                </p>
                <p className="p2">
                  <em>
                    Even with physical, technical and organizational measures
                    adopted by us, there is a residual risk of the loss of,
                    unauthorized access to or unauthorized disclosure of your
                    information which could result in financial or other harm to
                    you. In addition, there is a risk that your personal
                    information may be accessible to law enforcement and
                    national security authorities in the countries in which our
                    service providers are located.&nbsp;
                  </em>
                </p>
                <p className="p2">
                  <em>
                    You may withdraw your consent to the collection, storage,
                    use, disclosure and retention of your personal information
                    at any time.
                  </em>
                </p>
                <p className="p2">
                  <em>
                    Further information with respect to our privacy practices is
                    set out below.
                  </em>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p className="p3">&nbsp;</p>
        <ol className="ol1" start={2}>
          <li className="li2">
            <strong>
              CONSENT FOR THE COLLECTION, USE AND DISCLOSURE OF YOUR PERSONAL
              INFORMATION
            </strong>
          </li>
        </ol>
        <p className="p2">
          We may update or change the Privacy Policy from time to time. You
          agree that your continued use of the Website indicates your consent to
          this Privacy Policy and any changes made to it. When we make changes
          to the Privacy Policy, we will post the updated Privacy Policy on the
          Website and may notify you directly. We encourage you to check the
          Privacy Policy periodically for updates or changes. If you do not
          agree with changes made to this Privacy Policy, you should stop using
          our Website.
        </p>
        <p className="p3">&nbsp;</p>
        <ol className="ol1" start={3}>
          <li className="li2">
            <strong>WHAT KINDS OF INFORMATION DO WE COLLECT?</strong>
          </li>
        </ol>
        <p className="p2">
          The information we collect from you depends on how you use our
          Website.<span className="Apple-converted-space">&nbsp; </span>We will
          only collect personal information that is reasonably necessary for the
          purpose of providing our Services to you. You should exercise
          discretion when disclosing your personal information to us, and should
          not disclose sensitive or confidential information that you wish to
          remain private.
        </p>
        <p className="p2">The kinds of information we collect include:</p>
        <ol className="ol2" type="i">
          <li className="li2">
            <strong>
              Personal information and content you provide to us directly.
            </strong>{" "}
            When you register for our Services, we will collect certain basic
            information such as your name, address, email address and telephone
            number. We use this information to register your account and set up
            your profile on our Website. We also collect your login credentials
            for the purpose of administering the account. Users signing up as
            breeders on our Website will provide additional information about
            their breeder status, including breeder&rsquo;s history,
            certifications, registrations, puppy and breeding parent profiles,
            vaccination records and health certificates.
          </li>
        </ol>
        <p className="p5">
          We may offer sign in option that enables you to create an account and
          access the Website with your login credentials of third party social
          networking or integrated services, such as Facebook or Google. These
          services will allow the third party to authenticate your identity and
          provide you the option to share certain personal information with us.
        </p>
        <p className="p5">
          While using the Services, you may create or share content, photos,
          communications and other information which contain personal
          information. This information may be (i) used and stored by us for the
          purpose of providing the Services; and (ii) made available to other
          Website users, if you choose so, to facilitate dog purchase orders.
          Since our Website also enables you to directly contact another Website
          user, we advise that you consider how you share your personal
          information with others.
        </p>
        <p className="p5">
          We may also collect personal information when you contact us directly
          or through the Website. If you contact us, we may keep a record of the
          correspondence. We do not make any use of your email address or other
          contact information, other than to respond to the communication or to
          provide our Services.
        </p>
        <p className="p6">&nbsp;</p>
        <ol className="ol2" type="i" start={2}>
          <li className="li2">
            <strong>
              Non-identifiable information collected through automated
              technologies.
            </strong>{" "}
            We may use cookies, tags, web beacons, pixels and other technologies
            to track and collect information on how you use the Website. This
            may include information about your browser type, IP address,
            internet service provider, date/time stamp, time zone, and cookies
            that are installed on your device (&ldquo;
            <strong>Device Information</strong>&rdquo;).
          </li>
        </ol>
        <p className="p5">
          Additionally, we may track how you use the Website for the purpose of
          improving our Services. We may also collect unique device identifiers
          and geolocation information. Some browsers enable you to decline some
          personal identifiers, like cookies, however, doing so may affect your
          use of the Website and your ability to access certain features of the
          Website.
        </p>
        <p className="p6">&nbsp;</p>
        <ol className="ol2" type="i" start={3}>
          <li className="li2">
            <strong>Information others provide about you.</strong>{" "}
            <span className="s6">
              We may receive information from our partners and service providers
              in connection with providing Services to you. Additionally,{" "}
            </span>
            we may receive content, communications and information that other
            users provide when they use the Website. This can include
            information about you, such as when others send a message to you
            through the Website.
          </li>
        </ol>
        <p className="p6">&nbsp;</p>
        <ol className="ol1" start={4}>
          <li className="li2">
            <strong>HOW DO WE USE THE INFORMATION WE COLLECT? </strong>
          </li>
        </ol>
        <p className="p2">
          We use the personal information we collect for the following purposes:
        </p>
        <ul className="ul1">
          <li className="li7">
            To register you to use the Website and to authenticate users for
            security purposes;
          </li>
          <li className="li7">
            To cross reference with the personal information you previously
            provided to us to ensure accuracy;
          </li>
          <li className="li7">
            To administer the Website and your user account and to manage the
            emails that we send to you;
          </li>
          <li className="li7">
            To verify and fulfill dog purchase orders made through the Website;
          </li>
          <li className="li7">
            To provide registered users with Services through the Website;
          </li>
          <li className="li7">
            To obtain feedback on your experience using the Website;
          </li>
          <li className="li7">
            To contact you in connection with your account, dog purchase orders
            and to respond to your inquiries;
          </li>
          <li className="li7">
            If you opted in to allow us to do so, to communicate with you about
            our Services;
          </li>
          <li className="li7">
            To communicate with you, provided you have opted to receive such
            communication;
          </li>
          <li className="li7">
            To improve the Website&rsquo;s performance, functionality and user
            experience;
          </li>
          <li className="li7">
            To understand, research and improve our Services, including to
            compile aggregated non-identifiable information for research,
            marketing and analytics purposes;&nbsp;
          </li>
          <li className="li7">
            To protect you, our service providers and us against fraud;
          </li>
          <li className="li7">
            To combat harmful content and maintain the integrity of our
            Services;
          </li>
          <li className="li7">
            To enforce our Terms and Conditions and other policies or guidelines
            posted on the Website;
          </li>
          <li className="li7">
            To notify you in connection with changes to our Services or this
            Privacy Policy; and
          </li>
          <li className="li2">
            As permitted by, and to comply with, applicable laws and
            regulations.
          </li>
        </ul>
        <p className="p2">
          In the event we wish to use your personal information for any other
          purpose than as set out in this Section 4 above, we will notify you
          through an update to this Privacy Policy.
        </p>
        <p className="p3">&nbsp;</p>
        <ol className="ol1" start={5}>
          <li className="li2">
            <strong>USE AND DISCLOSURE OF PERSONAL INFORMATION</strong>
          </li>
        </ol>
        <p className="p2">
          Personal information submitted to Mawoo Pets is kept confidential,
          unless disclosed in accordance with this Privacy Policy.
        </p>
        <p className="p2">
          We do not sell, rent, or lease to third parties any personal
          information we collect about you. We may disclose or share personal
          information with our authorized employees, agents, partners, service
          providers and legal representatives for the purposes described in this
          Privacy Policy. We also share your personal information with service
          providers who assist with administering, hosting and supporting the
          Website. These service providers may be located outside of Canada (see
          Section 8 of this Privacy Policy). We reserve the right to contact any
          user at any time to forward information, respond to questions, or
          provide notification of any changes to this Privacy Policy, our Terms
          and Conditions or other policies.
        </p>
        <p className="p2">
          <strong>Service Providers:</strong>
        </p>
        <p className="p2">
          We may use outside service providers with respect to some of our
          Services. We provide information and content to our service providers
          only as necessary to provide you with the Services through our
          Website. Information that is shared is strictly related to your use of
          the Website and not for any third party use outside of the Website.
        </p>
        <p className="p2">
          We will disclose personal information only if consent is given by the
          relevant individual or:
        </p>
        <ol className="ol2">
          <li className="li7">
            when permitted or required by law, such as in response to a
            subpoena, warrant or other legal process;
          </li>
          <li className="li7">
            to enforce the Terms and Conditions or other policies applicable to
            our Services;
          </li>
          <li className="li7">
            to detect, prevent or mitigate fraud or security or technical
            issues;
          </li>
          <li className="li7">
            to protect against imminent harm to the rights, property or safety
            of our company, our customers or the public as required or permitted
            by law;
          </li>
          <li className="li7">
            to a transferee of all or part of Mawoo Pets under confidential
            terms consistent with this Privacy Policy;
          </li>
          <li className="li7">
            to our service providers in accordance with this Privacy Policy; or
          </li>
          <li className="li2">
            to meet legal obligations, including but not limited to regulatory
            reporting obligations.
          </li>
        </ol>
        <p className="p2">
          We use the following third parties and service providers:
        </p>
        <ol className="ol2">
          <li className="li7">
            we use{" "}
            <a href="https://aws.amazon.com/">
              <span className="s8">Amazon Web Services</span>
            </a>{" "}
            to host the Website’s platform and services;
          </li>
          <li className="li7">
            we use{" "}
            <a href="https://stripe.com/en-ca">
              <span className="s8">Stripe, Inc.</span>
            </a>{" "}
            to process payment transactions on our Website;
          </li>
          <li className="li7">
            we have partnered with{" "}
            <a href="https://www.afterpay.com/en-US">
              <span className="s8"> Afterpay</span>
            </a>{" "}
            and{" "}
            <a href="https://terracefinance.com/">
              <span className="s8"> Terrace Finance</span>
            </a>{" "}
            to offer financing for purchases on our Website;
          </li>
          <li className="li7">
            we use Google to message and video call between Website users;
          </li>
          <li className="li7">
            we use{" "}
            <a href="https://www.klaviyo.com/">
              <span className="s8">Klaviyo, Inc.</span>
            </a>{" "}
            to send email communications to our Website users;
          </li>
          <li className="li7">
            we use{" "}
            <a href="https://analytics.google.com/analytics/web/provision/#/provision">
              <span className="s8">Google Analytics</span>
            </a>{" "}
            to track anonymous activity and measure the usage patterns on our
            Website; and
          </li>
          <li className="li7">
            we use your Facebook or Google account credentials to register you
            to our Services, if you choose so, and maintain your account on our
            Website.
          </li>
        </ol>
        <p className="p2">
          <strong>Mawoo Pets Ltd. and Mawoo Pets LLC: </strong>
        </p>
        <p className="p2">
          Personal information collected or disclosed to Mawoo Pets Ltd. may
          also be disclosed and used by Mawoo Pets LLC, and personal information
          collected or disclosed to Mawoo Pets LLC may also be disclosed and
          used by Mawoo Pets Ltd., all in accordance with this Privacy Policy.
        </p>
        <p className="p3">&nbsp;</p>
        <ol className="ol1" start={6}>
          <li className="li2">
            <strong>HOW DO WE PROTECT YOUR PRIVACY?</strong>
          </li>
        </ol>
        <p className="p2">
          We keep the personal information we collect about you, and require
          that any parties we share your personal information with, keep your
          personal Information confidential in accordance with this Privacy
          Policy.
        </p>
        <p className="p2">
          We employ physical, technical and organizational safeguards
          appropriate to the sensitivity of the data to protect the personal
          information you provide to us from loss, theft, unauthorized
          disclosure, copying and unauthorized use or modification.
          Notwithstanding these measures, no collection, storage or transmission
          of information over the Internet on websites or otherwise can be
          guaranteed to be 100% secure, and therefore we cannot ensure, warrant
          or guarantee the security of any such personal information.
        </p>
        <p className="p2">
          If you think the personal information you provided to us has been
          improperly accessed or used, or if you suspect that unauthorized use
          of your personal information, please contact us immediately as set out
          in <span className="s9">Section 15 below.&nbsp;</span>
        </p>
        <p className="p2">
          Mawoo Pets shall comply with, and provide users with reasonable
          assistance in complying with applicable laws with respect to any
          unauthorized use, access, or disclosure of personal information.
        </p>
        <p className="p3">&nbsp;</p>
        <ol className="ol1" start={7}>
          <li className="li2">
            <strong>HOW LONG DO WE RETAIN YOUR PERSONAL INFORMATION?</strong>
          </li>
        </ol>
        <p className="p8">
          We will keep and retain your personal information in compliance with
          our legal obligations, and only as long as necessary for the purposes
          for which it was collected. Personal information that is no longer
          required will be securely destroyed, erased or made anonymous
          according to our guidelines and procedures. For further details on our
          data retention periods, please contact us using the information
          provided in Section 15 below.
        </p>
        <p className="p9">&nbsp;</p>
        <ol className="ol1" start={8}>
          <li className="li2">
            <strong>WHERE IS YOUR PERSONAL INFORMATION STORED?</strong>
          </li>
        </ol>
        <p className="p2">
          We currently store and process your personal information and other
          content you provide to us on servers hosted by Amazon Web Services. In
          some circumstances, your personal information may be stored,
          processed, shared or otherwise used on servers belonging to other
          third party service providers located within or outside of Canada,
          including those in the United States, or to other trusted third
          parties based in other countries. Our service providers are only
          permitted to store, process and access your personal information, and
          are not otherwise authorized to collect, use or disclose your personal
          information, except in accordance with the purposes set out in this
          Privacy Policy or as required by applicable law. However, it is
          possible that foreign governments, courts, law enforcement or
          regulatory agencies may be able to access your personal information
          under foreign laws.
        </p>
        <p className="p2">
          By using our Services or otherwise providing us with personal
          information, you agree to the transferring of your personal
          information in accordance with this Privacy Policy and applicable data
          protection laws and regulations.
        </p>
        <p className="p10">&nbsp;</p>
        <ol className="ol1" start={9}>
          <li className="li2">
            <strong>
              YOUR RIGHTS AND ACCESS TO THE INFORMATION WE COLLECT
            </strong>
          </li>
        </ol>
        <p className="p2">
          You can review, correct, update, or change your personal information
          by changing the relevant setting in your account.&nbsp;You may also
          opt out of receiving certain communications or emails from us, such as
          marketing messages, by following instructions provided in each such
          communication. However, you cannot opt out of receiving all emails
          from us, such as emails about the status of your account or dog
          purchase order.
        </p>
        <p className="p2">
          You have the right to access personal information that Mawoo Pets
          holds about you. You can request from us information about:
        </p>
        <ul className="ul1">
          <li className="li2">the personal information we hold about you;</li>
          <li className="li2">
            the categories of personal information concerned;
          </li>
          <li className="li2">the purposes of the processing;</li>
          <li className="li2">
            details to whom your personal information has been/will be
            disclosed;
          </li>
          <li className="li2">how long we retain your personal information;</li>
          <li className="li7">
            if we did not collect the information directly from you, information
            about the source; and
          </li>
          <li className="li2">
            how to lodge a complaint with the correct supervisory authority.
            <span className="Apple-converted-space">&nbsp; &nbsp;</span>
          </li>
        </ul>
        <p className="p2">You may also request from us the following:</p>
        <ul className="ul1">
          <li className="li7">
            that we update any incomplete or inaccurate information about you;
            and
          </li>
          <li className="li2">
            that we delete your personal information in accordance with
            applicable laws.
          </li>
        </ul>
        <p className="p2">
          You may request this information by contacting us as set out in{" "}
          <span className="s9">Section 15 below.&nbsp;</span>
        </p>
        <p className="p2">
          Under certain circumstances, it is possible that we may not be able to
          provide you with all of the information you may have requested.
          Exceptions may include information that is prohibitively costly to
          provide, information that contains references to other individuals,
          information that cannot be disclosed for legal, security or commercial
          proprietary reasons, or information that is subject to
          solicitor-client or litigation privilege. Fees may be applied to any
          copy of the requested personal information. We will provide the
          reasons for denying access upon request.
        </p>
        <p className="p2">
          It is your responsibility to notify us of any changes to your personal
          information, including contact information, so we can contact you and
          inform you with respect to your use of our Services. Failure to inform
          us of such changes is a breach of our Terms and Conditions and may
          result in suspension or termination of the Services we provide to you.
        </p>
        <p className="p3">&nbsp;</p>
        <ol className="ol1" start={10}>
          <li className="li2">
            <strong>
              WITHDRAWING CONSENT TO THE USE OF YOUR PERSONAL INFORMATION
            </strong>
          </li>
        </ol>
        <p className="p2">
          You may withdraw your consent to the collection, storage, use,
          disclosure and retention of your personal information at any time,
          subject to legal and contractual restrictions and reasonable notice.
          To do this, please contact us as set out in{" "}
          <span className="s9">Section 15 below. </span>Withdrawal of your
          consent to the collection, storage, use, disclosure and retention of
          personal information may result in you being unable to continue use of
          the Website or our Services.
        </p>
        <p className="p3">&nbsp;</p>
        <ol className="ol1" start={11}>
          <li className="li2">
            <strong>THIRD PARTY LINKS</strong>
          </li>
        </ol>
        <p className="p2">
          Our Website and the emails that we may send to you may contain
          hypertext links to the websites of third parties. We are not
          responsible for the privacy practices or the content of such other
          websites. Linked websites are maintained by third parties. Such links
          are provided for your convenience and reference only. We do not
          operate or control, in any respect, any information, software,
          products or services available on such third party websites. The
          inclusion of a link to a website does not imply any endorsement of the
          service or the site, its contents, or its sponsoring organization. We
          encourage our Website users to be aware that when they leave our
          Website, they should carefully read the privacy statements of each and
          every site that collects personally identifiable information.
        </p>
        <p className="p3">&nbsp;</p>
        <ol className="ol1" start={12}>
          <li className="li2">
            <strong>TERMS AND CONDITIONS</strong>
          </li>
        </ol>
        <p className="p2">
          Our{" "}
          <a href={`${process.env.NEXT_PUBLIC_ROOT_URL}/tos`}>
            <span className="s8">Terms and Conditions </span>
          </a>
          . This Privacy Policy is incorporated into our Terms and Conditions.
        </p>
        <p className="p3">&nbsp;</p>
        <ol className="ol1" start={13}>
          <li className="li2">
            <strong>PRIVACY POLICY CHANGES AND UPDATES</strong>
          </li>
        </ol>
        <p className="p2">
          As per Section 2 above, we may revise this Privacy Policy from time to
          time.<span className="Apple-converted-space">&nbsp; </span>It is your
          responsibility to check this Privacy Policy periodically for any
          updates or changes. We may also notify you directly of any updates to
          this Privacy Policy or our privacy practices. Changes will be
          effective as of the time of posting on our Website. Your continued use
          of the Website constitutes your consent to any updated Privacy Policy.
        </p>
        <p className="p3">&nbsp;</p>
        <ol className="ol1" start={14}>
          <li className="li2">
            <strong>ROLES AND RESPONSIBILITIES OF EACH COMPANY</strong>
          </li>
        </ol>
        <p className="p4">
          Each of Mawoo Pets Ltd. and Mawoo Pets LLC are entitled to the benefit
          of this Privacy Policy. The responsibilities of each under this
          Privacy Policy are several and the responsibilities of each are not
          joint.
        </p>
        <p className="p3">&nbsp;</p>
        <ol className="ol1" start={15}>
          <li className="li2">
            <strong>CONTACT US</strong>
          </li>
        </ol>
        <p className="p2">
          To review or update your personal information in our possession,
          withdraw consent for the collection, use, and/or disclosure of your
          personal information, or inquire about the details of this Privacy
          Policy, please contact us at:{" "}
          <a href="mailto:privacy@mawoopets.com">
            <span className="s8">privacy@mawoopets.com</span>
          </a>
          .
        </p>
        <p className="p2">
          Please note that when requesting access to personal information we may
          request confirmation of your identity to protect you.
        </p>
        <p className="p3">&nbsp;</p>
      </main>
      <Footer />
    </div>
  );
}
